import { CurricularUnitServiceInterface } from 'domain/services';
import { GetAllCurricularUnitsUserUseCaseInterface } from 'domain/usecases';

export class CurricularUnitService implements CurricularUnitServiceInterface {
  constructor(
    private readonly _getAllCurricularUnitsUserUseCase: GetAllCurricularUnitsUserUseCaseInterface,
  ) {}

  async getAllCurricularUnitsUser(
    params: GetAllCurricularUnitsUserUseCaseInterface.Params,
  ): Promise<GetAllCurricularUnitsUserUseCaseInterface.Result> {
    return await this._getAllCurricularUnitsUserUseCase.execute(params);
  }
}
